"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Functor$clear = exports.Functor$isEmpty = exports.Functor$remove = exports.Functor$add = exports.FunctorItem$new = exports.Functor$create = void 0;
function Functor$create(returns) {
    if (returns === void 0) { returns = false; }
    var funcs = [];
    // TODO: Detect functor invocation resulting in continually adding subscribers
    function Functor$fn() {
        var returnsArray;
        if (returns) {
            returnsArray = [];
        }
        for (var i = 0; i < funcs.length; ++i) {
            var item = funcs[i];
            // Don't re-run one-time subscriptions that have already been applied.
            if (item.applied === true) {
                continue;
            }
            // Ensure that there is either no filter or the filter passes.
            if (!item.filter || item.filter.apply(this, arguments) === true) {
                // If handler is set to execute once,
                // remove the handler before calling.
                if (item.once === true) {
                    // Mark as applied but leave item in array to avoid potential
                    // problems due to re-entry into event invalidating iteration
                    // index. In some cases re-entry would be a red-flag, but for
                    // "global" events, where the context of the event is derived
                    // from the arguments, the event could easily be re-entered
                    // in a different context with different arguments.
                    item.applied = true;
                }
                // Call the handler function.
                var returnValue = item.fn.apply(this, arguments);
                if (returns) {
                    returnsArray.push(returnValue);
                }
            }
        }
        if (returns) {
            return returnsArray;
        }
    }
    ;
    var f = Functor$fn;
    f._funcs = funcs;
    f.add = Functor$add;
    f.remove = Functor$remove;
    f.isEmpty = Functor$isEmpty;
    f.clear = Functor$clear;
    return f;
}
exports.Functor$create = Functor$create;
function FunctorItem$new(fn, filter, once) {
    if (filter === void 0) { filter = null; }
    if (once === void 0) { once = false; }
    var item = { fn: fn };
    if (filter != null) {
        item.filter = filter;
    }
    if (once != null) {
        item.once = once;
    }
    return item;
}
exports.FunctorItem$new = FunctorItem$new;
function Functor$add(fn, filter, once) {
    if (filter === void 0) { filter = null; }
    if (once === void 0) { once = false; }
    var item = FunctorItem$new(fn, filter, once);
    this._funcs.push(item);
}
exports.Functor$add = Functor$add;
function Functor$remove(fn) {
    for (var i = this._funcs.length - 1; i >= 0; --i) {
        if (this._funcs[i].fn === fn) {
            this._funcs.splice(i, 1);
            return true;
        }
    }
    return false;
}
exports.Functor$remove = Functor$remove;
function Functor$isEmpty(args) {
    if (args === void 0) { args = null; }
    return !this._funcs.some(function (item) { return item.applied !== true && (!args || !item.filter || item.filter.apply(this, args)); }, this);
}
exports.Functor$isEmpty = Functor$isEmpty;
function Functor$clear() {
    this._funcs.length = 0;
}
exports.Functor$clear = Functor$clear;
